import { request } from "../generic/request";

import { type UseQueryOptions, type UseQueryResult, useQuery } from "./react-query";

export type ExtensionType = "searchTypes" | "searchTopics";

export const useQueryPluginExtensions = <TResult = Array<string>>(
	pluginId: string,
	extensionType: ExtensionType,
	uiRequestTimeout: number,
	config: { integrationType: string },
	options?: UseQueryOptions<Array<string>, Error, TResult>,
): UseQueryResult<TResult, Error> =>
	useQuery(
		["plugin", pluginId, "extension", extensionType, uiRequestTimeout, config.integrationType],
		() =>
			request<{ success: Array<string> }>(`api/plugins/${pluginId}/extension/${extensionType}`, {
				method: "POST",
				query: {
					uiRequestTimeout,
				},
				body: config,
			}).then((response) => response.success),
		options,
	);
